import billPrintFromTableStyle from "./billPrintFromTableStyle"
import { ReactTabulator } from "react-tabulator";
import { useState, useContext, forwardRef, useEffect } from "react";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import { PrintDataContext } from "../../Pages";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import axios from "axios";
import React, { useRef } from "react";
import tableCalc from "../../utils/tableCalc";
import commaSeparator from "../../utils/CommaSeparator";
import Barcode from "react-barcode";
import "./Factorprint.scss";
import BarcodeLabel from "../BarcodeLabel";
import PaperWidthToUse from "../BarcodeLabel/PaperWidthToUse";

// import dataprint1 from "./file.json";

const InTable = (props) => {
  const { mapData } = props;
  return (
    <>
      {mapData.map((v) => (
        <>
          {!v.subList && (
            <>
              <ul className="text-end py-1 px-3 d-flex">
                <li className={"text-center li-width"}>{v.id}</li>
                <li className={" ltr text-center fd-font w-50"}>
                  <span className={"px-2"}>
                    {Number(v.price).toLocaleString()}
                  </span>
                </li>
              </ul>
            </>
          )}
          {v.subList && (
            <ul className="text-end  px-3 d-flex">
              <li className="text-end py-1 px-3 ">
                <span className={""}>{v.id}</span>:
              </li>
              <li className={"printMainDivStyle "}>
                {v.data.map((subListValue) => (
                  <ul className="text-end py-1 px-3 d-flex">
                    <li className={"text-center"}> {subListValue.name} :</li>
                    <li className={" ltr fd-font "}>
                      {" "}
                      {Number(subListValue.price).toLocaleString()}{" "}
                    </li>
                  </ul>
                ))}
              </li>
            </ul>
          )}
        </>
      ))}
    </>
  );
};
const ComponentToPrint = forwardRef((props, ref) => {
  const dataprint1 = useContext(PrintDataContext);

  const [balanceTableData, setBalanceTableData] = useState(dataprint1);
  const [data, setData] = useState(20);

  const [selectedRow, setSelectedRow] = useState();
  const printDom = useRef(null);
  const tableRef = useRef(null);

  function rowClickHandler(e, row) {
    row.getTable().getSelectedRows().length === 0
      ? setSelectedRow()
      : setSelectedRow(row);
  }

  var fieldArray = [];
  if (dataprint1.type === "tablePrint") {
    for (const dataIn in dataprint1.data) {
      let tempArray = [];
      dataprint1.data[dataIn].column.map(
        (p) => tempArray.push(p.field) // console.log(p.field + " : " + dataIn)
      );
      fieldArray.push(tempArray);
    }
  }

  const formDOM = useRef(null);
  const [showMonthYearToSelect, setShowMonthYearToSelect] = useState(false);
  const [showDateToSelect, setShowDateToSelect] = useState(false);

  const sendNewDataToUpdateBalance = (id, requestType) => {
    let elements = "";
    let paramsToSend = {};

    let inputbox = "";
    if (requestType === "yearMonth") {
      elements = formDOM.current.getElementsByTagName("input");
      for (let element of elements) {
        if (element.name === "startDate") {
          inputbox = element.value;
        }
      }

      let arrayplz = inputbox.split("/");
      const monthsListArray = [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ];
      let whichMonth = arrayplz[0];
      let whichYear = arrayplz[1];
      let temp22 = whichMonth.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
      let whichMonthToNumber = parseInt(temp22, 10);

      console.log(whichMonthToNumber);
      let monthToSendBack = monthsListArray[whichMonthToNumber - 1];
      let yearToSendBack = parseInt(
        whichYear.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)),
        10
      );

      paramsToSend = {
        id: id,
        type: requestType,
        filter: { month: monthToSendBack, year: yearToSendBack },
      };
    }

    if (requestType === "date") {
      let v1,
        v2 = "";
      elements = formDOM.current.getElementsByTagName("input");
      for (let element of elements) {
        if (element.name === "startDate") {
          v1 = element.value;
        }
        if (element.name === "endDate") {
          v2 = element.value;
        }
      }
      paramsToSend = {
        id: id,
        type: requestType,
        filter: { startDate: v1, endDate: v2 },
      };
    }

    var id = id;
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/mreport/`,
      params: paramsToSend,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then(({ data }) => {
      if (data) {
        setBalanceTableData(data);
      } else {
        console.log(
          "when send request and receive data ... look Like Data doesnt received"
        );
      }
    });
  };

  // const [startDate, setStartDate] = useState(new Date());

  const nullToZero = (input) => (input === null ? 0 : input);
  const processData = (inputObject) => {
    let rowData = "";
    // debugger
    let rtValue = 0;
    for (let item of inputObject) {
      if (item.subList === false) {
        rtValue = rtValue + +nullToZero(item.price);
        // console.log("sum: " + sum ,"item:" + item , "subExpenseItemElement:"+ "-" )
        rowData += (
          <div className="text-end py-3 px-3">
            {" "}
            {item.id} :{" "}
            <div className={"ltr d-inline-block fd-font"}>
              {Number(item.price).toLocaleString()}
            </div>
          </div>
        );
        // tempResult=  <div className="text-end py-3 px-3">  {item.id} : <div className={"ltr d-inline-block fd-font"}>{Number(item.price).toLocaleString()}</div></div>
      } else {
        for (let subExpenseItemElement of item.data) {
          rtValue = rtValue + +nullToZero(subExpenseItemElement.price);
          rowData += (
            <div className="text-end py-3 px-3 mx-5">
              {" "}
              {item.id} :{" "}
              <div className={"ltr d-inline-block fd-font"}>
                {Number(item.price).toLocaleString()}
              </div>
            </div>
          );
        }
      }
    }
    const resultHtml = <>{rowData}</>;
    return { rtValue, resultHtml };
  };

  const [sumItems, setSumItems] = useState({
    expenseSum: "",
    expenseSumJsx: "",
    incomeSum: "",
    incomeSumJsx: "",
  });
  // const billPrintFromTableRef = useRef()

  const $ = q => document.querySelector(q)

  // Inner Data
  const innerTextData = (id, label, value) => {
    // debugger;
    const element = [...document.querySelectorAll(`#${id}`)]

    element.map((item) => {
      if ($(`#${id}`)) {
        item.children[0].textContent = label
        // جمع کل رو سه رقم جدا کن
        if(id==="Memo67" || id==="Memo65"){
          item.children[1].textContent =   commaSeparator(value)
        }else {
          item.children[1].textContent = value
        }
        if(value!=='0'){
          item.classList.remove("d-none");
        }

      }
    })
  }

  const [barcodeData, setBarcodeData] = useState("");
  useEffect(() => {
    if (dataprint1.type === "tablePrint") {
      dataprint1.headerAndFooter.header.map((item) => {
        // console.log(item.id)
        let headerItem = printDom.current.querySelector(`#${item.id}`);
        let textValue = item.value;
        if (headerItem !== null) {
          if (headerItem.tagName === "IMG") {
            headerItem.src = "../" + textValue;
          } else {
            headerItem.innerText = textValue;
          }
        }
      });
    }
    if(dataprint1.type === "billPrintFromTable"){
        if(ref.current){

              //logo
              for (let  item of dataprint1.headerAndFooter.header) {
                if(item.id==="Memo100"){
                  document.getElementsByClassName("bill__logo")[0].innerHTML =`<img className="img-fluid" src ="${item.value}"  alt="لوگو"/>`
                }
              }

          for (let  item of dataprint1.headerAndFooter.detail) {
            if(item.id==="Memo72"){
              setBarcodeData(item.value)
            }
          }

              // Like jQuery
            // Get The Column & Data Table
              const [columnTable, dataTable] = [$("table.header"), $("table.body")];
             // Create Base Variables
              let [columns, data] = [``, ``];

                // ! Header (Info) & Footer (End)
              ["header", "user", "detail", "text"].map((item) => {
                dataprint1.headerAndFooter[item].map((item) => {
                  innerTextData(item.id, item.label.split("/")[0], item.value)
                })
              })
              // ! Body (Data)
              // Get Columns
              columns += `<td>ردیف</td>`
                // debugger

              // dataprint1.data[0].column.map((item) => {
              //   columns += `<td>${item.title}</td>`
              // })
            Object.entries(dataprint1.data[0].column).forEach(([key, value]) => {
              // console.log(key, value);
              columns += `<td>${value.title}</td>`
            });

            // Get Data's
            dataprint1.data[0].data.map((item, number) => {
              // اینجا نگاه میکنم


              data += `<tr>
                        <td>${number+1}</td>
                        <td>${item.CKALA}</td>
                        <td>${item.NKALA}</td>
                        <td>${commaSeparator(item.GHVAHED)}</td>
                        <td>${item.TE}</td>
                        <td>${commaSeparator(item.JAM)}</td>
                    </tr>`
            })
              // Append Data & Columns
              $("#columns").innerHTML = columns
              $("#data").innerHTML = data
        }
    }
  }, []);

  useEffect(() => {
    let data = balanceTableData;
    let expenseSum = {rtValue:"",resultHtml:""};
    let incomeSum =  {rtValue:"",resultHtml:""};
    if (data.type === "costAndBenefit" || data.type === "balance") {
      expenseSum = processData(dataprint1.data.expense);
      incomeSum = processData(dataprint1.data.income);
    }


    setSumItems({
      expenseSum: expenseSum.rtValue,
      expenseSumJsx: expenseSum.resultHtml,
      incomeSum: incomeSum.rtValue,
      incomeSumJsx: incomeSum.resultHtml,
    });
  }, []);

  if (balanceTableData.type === "balance") {
    return (
      <div className={"printMainDivStyle"} ref={ref}>
        <div className={"row "}>
          <div className={"col-12 text-center mt-5"}>
            <div className={"text-center fw-bold mb-3"}>ترازنامه</div>
            <div className={"text-center "}>
              {balanceTableData.header.shopName}
            </div>
            <div className={"text-center my-2"}>{dataprint1.title}</div>
            <div className={"text-center mb-2"}>
              {balanceTableData.header.date}
            </div>
          </div>
          <div className="rounded border border-dark row px-0">
            <div
              className={
                "col-6 px-0 border-start border-dark position-relative"
              }
            >
              <div className={"text-center  border-bottom border-dark py-3"}>
                دارایی ها
              </div>
              <InTable mapData={balanceTableData.data.income} />
              {/*{sumItems.expenseSumJsx}*/}
              <div className="text-end py-3 px-3">
                &nbsp;<span>&nbsp;</span>
              </div>

              <div
                className={
                  "border-top border-dark py-3 position-absolute bottom-0   text-center w-100"
                }
              >
                جمع :
                <div className={"ltr d-inline-block fd-font"}>
                  {sumItems.incomeSum}
                </div>
              </div>
            </div>
            <div className={"col-6 px-0 border-dark position-relative"}>
              <div className={"text-center  border-bottom border-dark py-3"}>
                بدهی ها
              </div>
              <InTable mapData={balanceTableData.data.expense} />
              <div className="text-end py-3 px-3">
                &nbsp;<span>&nbsp;</span>
              </div>
              <div
                className={
                  "border-top border-dark py-3 position-absolute bottom-0  text-center w-100 "
                }
              >
                {" "}
                جمع :
                <div className={"ltr d-inline-block fd-font"}>
                  {sumItems.expenseSum}
                </div>
              </div>
            </div>
            <div
              className={
                "col-6 px-0 border-dark position-relative border-top w-100"
              }
            >
              <div className={"my-2"}>
                جمع کل: &nbsp;&nbsp;&nbsp;
                <div className={"ltr d-inline-block fd-font"}>
                  {sumItems.incomeSum - sumItems.expenseSum}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={"d-print-none mt-5"}>
          {localStorage.getItem("balanceHasyearMonthSection") === "true" && (
            <button
              className={"btn btn-success mx-2"}
              onClick={() => {
                setShowMonthYearToSelect(!showMonthYearToSelect);
                setShowDateToSelect(false);
              }}
            >
              {" "}
              فیلتر ماه و سال
            </button>
          )}
          {localStorage.getItem("balanceHasDateSection") === "true" && (
            <button
              className={"btn btn-success mx-2"}
              onClick={() => {
                setShowDateToSelect(!showDateToSelect);
                setShowMonthYearToSelect(false);
              }}
            >
              {" "}
              انتخاب بازه تاریخ{" "}
            </button>
          )}
          {showMonthYearToSelect && (
            <div>
              <div className={"my-4 rounded border border-black"}>
                <div className={"my-3"}>
                  <form
                    ref={formDOM}
                    className={"col-6 row  gx-2 mx-auto my-0"}
                  >
                    <div className="col-12">
                      <div className="form-control">
                        <DatePicker
                          calendar={persian}
                          className="form-control"
                          placeholder="انتخاب ماه و سال"
                          name={"startDate"}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          onlyMonthPicker={true}
                        />
                      </div>
                    </div>
                    <div className="col-12 my-4">
                      <button
                        className={"btnCustom btnSubmit"}
                        type="button"
                        onClick={() =>
                          sendNewDataToUpdateBalance(1, "yearMonth")
                        }
                      >
                        {" "}
                        نمایش تراز نامه
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
          {showDateToSelect && (
            <div className={"my-2 rounded border border-black"}>
              <div className={"my-3"}>
                <form ref={formDOM} className={"col-6 row  gx-2 mx-auto my-0"}>
                  <div className="col-12">
                    <div className="form-control">
                      <DatePicker
                        calendar={persian}
                        className="form-control"
                        placeholder="از تاریخ"
                        name={"startDate"}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </div>
                  </div>
                  <div className="col-12 my-4">
                    <div className="form-control col">
                      <DatePicker
                        calendar={persian}
                        className="form-control"
                        placeholder="تا تاریخ"
                        name={"endDate"}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <button
                      className={"btnCustom btnSubmit"}
                      type="button"
                      onClick={() => sendNewDataToUpdateBalance(1, "date")}
                    >
                      {" "}
                      نمایش تراز نامه
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
  if (balanceTableData.type === "costAndBenefit") {
    return (
      <div className={"printMainDivStyle"} ref={ref}>
        <div className={"row "}>
          <div className={"col-12 text-center mt-5"}>
            <div className={"text-center fw-bold mb-3"}>گزارش سود و زیان</div>
            <div className={"text-center"}>
              {balanceTableData.header.shopName}
            </div>
            <div className={"text-center my-2"}>{dataprint1.title}</div>
            <div className={"text-center mb-2"}>
              {balanceTableData.header.date}
            </div>
          </div>
          <div className="rounded border border-dark row px-0">
            <div
              className={
                "col-6 px-0 border-start border-dark position-relative"
              }
            >
              <div className="cell-head">فروش کل</div>
              <div className="cell-benefit"> گروه هزینه</div>

              {balanceTableData.data.expense[1].data.map((item) => (
                <div className="cell-benefit">{item.name}</div>
              ))}
              <div className="cell-head">جمع کل</div>
            </div>
            <div className={"col-6 px-0 border-dark position-relative"}>
              <div className="cell-head">
                {balanceTableData.data.income[0].price}
              </div>
              <div className="cell-benefit"> مبلغ </div>
              {balanceTableData.data.expense[1].data.map((item) => (
                <div className="cell-benefit">{item.price}</div>
              ))}
              <div className="cell-head">
                {balanceTableData.data.income[0].price - sumItems.expenseSum}
              </div>
            </div>
          </div>
        </div>
        <div className={"d-print-none mt-5"}>
          {localStorage.getItem("balanceHasyearMonthSection") === "true" && (
            <button
              className={"btn btn-success mx-2"}
              onClick={() => {
                setShowMonthYearToSelect(!showMonthYearToSelect);
                setShowDateToSelect(false);
              }}
            >
              {" "}
              فیلتر ماه و سال
            </button>
          )}
          {localStorage.getItem("balanceHasDateSection") === "true" && (
            <button
              className={"btn btn-success mx-2"}
              onClick={() => {
                setShowDateToSelect(!showDateToSelect);
                setShowMonthYearToSelect(false);
              }}
            >
              {" "}
              انتخاب بازه تاریخ{" "}
            </button>
          )}
          {showMonthYearToSelect && (
            <div>
              <div className={"my-4 rounded border border-black"}>
                <div className={"my-3"}>
                  <form
                    ref={formDOM}
                    className={"col-6 row  gx-2 mx-auto my-0"}
                  >
                    <div className="col-12">
                      <div className="form-control">
                        <DatePicker
                          calendar={persian}
                          className="form-control"
                          placeholder="انتخاب ماه و سال"
                          name={"startDate"}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          onlyMonthPicker={true}
                        />
                      </div>
                    </div>
                    <div className="col-12 my-4">
                      <button
                        className={"btnCustom btnSubmit"}
                        type="button"
                        onClick={() =>
                          sendNewDataToUpdateBalance(1, "yearMonth")
                        }
                      >
                        {" "}
                        نمایش تراز نامه
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
          {showDateToSelect && (
            <div className={"my-2 rounded border border-black"}>
              <div className={"my-3"}>
                <form ref={formDOM} className={"col-6 row  gx-2 mx-auto my-0"}>
                  <div className="col-12">
                    <div className="form-control">
                      <DatePicker
                        calendar={persian}
                        className="form-control"
                        placeholder="از تاریخ"
                        name={"startDate"}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </div>
                  </div>
                  <div className="col-12 my-4">
                    <div className="form-control col">
                      <DatePicker
                        calendar={persian}
                        className="form-control"
                        placeholder="تا تاریخ"
                        name={"endDate"}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <button
                      className={"btnCustom btnSubmit"}
                      type="button"
                      onClick={() => sendNewDataToUpdateBalance(1, "date")}
                    >
                      نمایش تراز نامه
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
  if (balanceTableData.type === "tablePrint") {
    // جدول
    return (
      <div ref={ref} className={"position-relative"}>
        <div ref={tableRef} className={"iwannaTestit"}>
          <div className="print-container position-relative" ref={printDom}>
            {/**/}
            <div className="header">
              <div className="rowHeader">
                <div className="client-info">
                  <div id="Memo69"></div>
                  <div id="Memo62"></div>
                  <div id="Memo60"></div>
                </div>
                <div className="topHeader ">
                  <h1 className="font" id="Memo10"></h1>
                  <h2 id="124" className="font">
                    {dataprint1.title}
                  </h2>
                </div>
                <div className="logo">
                  <img id="Memo100" src="" />
                </div>
              </div>
            </div>
            <div className="footer">
              <div className="rowFooter ">
                <div className="fontSize firstCulmn">
                  {dataprint1.headerAndFooter.detail.map((item) => (
                    <ul>
                      <li>{item.label}</li>
                      <li>{item.value}</li>
                    </ul>
                  ))}
                </div>
                <div className="fontSize secondCulmn">
                  <span>
                    {dataprint1.headerAndFooter.text[0] &&
                      dataprint1.headerAndFooter.text[0].value}
                  </span>
                </div>
                <div className="fontSize thirdCulmn">
                  {dataprint1.headerAndFooter.user.map((item) => (
                    <ul>
                      <li>{item.label}</li>
                      <li>{item.value}</li>
                    </ul>
                  ))}
                </div>
              </div>
            </div>
            {/**/}

            <table className="mainCont">
              <thead className={"header-space"}>
                <td colspan={4} className={"tdStyleHead"}>
                  {/*لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.*/}
                </td>
              </thead>
              {/**/}
              <tbody>
                {dataprint1.data.map((tabledata, index) => (
                  <>
                    {/*{tabledata.column.map(p => array.push(p.field))}*/}
                    {/*<td></td>*/}
                    <tr>
                      <th className={"headerStyleForTable"} colspan="4">
                        {tabledata.entityName}
                      </th>
                    </tr>
                    {/*<td></td>*/}
                    <tr>
                      {tabledata.column.map((p) => (
                        <th>{p.title}</th>
                      ))}
                    </tr>
                    {tabledata.data.map((key) => (
                      <tr>
                        {fieldArray[index].map((input) => (
                          <td>{key[input]}</td>
                        ))}
                      </tr>
                    ))}
                  </>
                ))}
              </tbody>
              {/**/}

              <tfoot className={"footer-space"}>
                <td colspan={4} className={"tdStyleHead"}></td>
              </tfoot>
            </table>

            {/**/}

            {/*{dataprint1.data.map(item =>*/}
            {/*    (<><h6 className="table-titr">{item.entityName}</h6>*/}
            {/*        <ReactTabulator*/}

            {/*            data={item.data}*/}
            {/*            columns={item.column}*/}
            {/*            options={{selectable: 1}}*/}
            {/*            events={{rowClick: rowClickHandler}}*/}
            {/*        /></>))}*/}
            {/*{dataprint1.data.map(item =>*/}

            {/*    (<><h6 className="table-titr">{item.entityName}</h6>*/}
            {/*        <ReactTabulator*/}

            {/*            data={item.data}*/}
            {/*            columns={item.column}*/}
            {/*            options={{selectable: 1}}*/}
            {/*            events={{rowClick: rowClickHandler}}*/}
            {/*        /></>))}*/}

            {/**/}
          </div>
        </div>
      </div>
    );
  }
  if (balanceTableData.type === "billPrintFromTable"){
    return  <div ref={ref}>
      <style>{billPrintFromTableStyle}</style>
      <main className="container__billPrintFromTable" dir="rtl">
        <header className="factor-header">
          <div className="bill__logo">
          </div>
          <div className="title">
            <b> صورتحساب فاکتور</b>
          </div>
          <div className={""}>
            <div className="box fd-font small_font_bill" id="Memo72"><span>-</span>:<span>-</span></div>
            <div>
              {barcodeData && <Barcode
                  value={barcodeData}
                  height={30}
                  // height={12}
                  format={"CODE128B"}
                  width={1.3}
                  // width={12}
                  fontSize={10}
                  margin={0}
                  displayValue={false}
              />}
            </div>
            <div className="box fd-font small_font_bill" id="Memo69"><span>-</span>:<span>-</span></div>
          </div>
        </header>

        <table className="header_useless">
          <tr>
            <td colSpan="3" className="center">فروشنده</td>
            <td colSpan="3" className="center">خریدار</td>
          </tr>
          <tr>
            <td colSpan="3">
              <div className="content">
                <div className="float">
                  <div className="box" id="Memo10"><b>-</b> : <span>-</span></div>
                </div>
                <div className="float">
                  <div className="box" id="Memo21"><b>-</b> : <span>-</span></div>
                  <div className="box" id="Memo22"><b>-</b> : <span>-</span></div>
                </div>
                <div className="float">
                  <div className="box" id="Memo12"><b>-</b> : <span>-</span></div>
                  <div className="box" id="Memo11"><b>-</b> : <span>-</span></div>
                </div>
              </div>
            </td>
            <td colSpan="3">
              <div className="content">
                <div className="float">
                  <div className="box" id="customerName"><b> نام خریدار</b> : <span>  </span></div>
                </div>
                <div className="float">
                  <div className="box" id="customerMobile"><b>شماره موبایل</b> : <span>  </span></div>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <table className="body">
          <thead>
          <tr id="columns"></tr>
          </thead>
          <tbody id="data">
          </tbody>
          <tfoot>
          <tr id="Memo68" className="d-none">
            <td colSpan="4" className="left"></td>
            <td colSpan="2"></td>
          </tr>
          <tr id="Memo65" className="d-none" >
            <td colSpan="4" className="left"></td>
            <td colSpan="2"></td>
          </tr>
          <tr id="Memo64" className="d-none" >
            <td colSpan="4" className="left" ></td>
            <td colSpan="2"></td>
          </tr>
          <tr id="Memo67" className="left d-none">
            <td colSpan="2"></td>
            <td colSpan="4"></td>
          </tr>

          </tfoot>
        </table>
        <div className="d-flex justify-content-center align-items-center  text-center">
          <div className="box" id="Memo18"><span className={"d-none"}>-</span>  <span>-</span></div>
        </div>
      </main>
    </div>
  }
  if (balanceTableData.type === "barcodePrintFromBuyBill"){
    return (
        <div ref={ref}>
          {balanceTableData.data.length>0 &&

                <>
                  {/*<div>*/}
                  {/*  {v.barcodeCount},*/}
                  {/*  {v.barcodeLength},*/}
                  {/*  {v.barcodeWidth},*/}
                  {/*  {v.paperWidth},*/}
                  {/*  {v.productCode},*/}
                  {/*  {v.productColor},*/}
                  {/*  {v.productName},*/}
                  {/*  {v.productPrice},*/}
                  {/*  {v.productSize},*/}
                  {/*  {v.productFont}*/}
                  {/*</div>*/}
                  <PaperWidthToUse
                    paperWidth=   {balanceTableData.data[0].paperWidth}
                    barcodeLength=   {balanceTableData.data[0].barcodeLength}
                    barcodeWidth=   {balanceTableData.data[0].barcodeWidth}
                    productFont=   {balanceTableData.data[0].productFont}
                    priceFont=   {balanceTableData.data[0].priceFont}
                    data=    {balanceTableData.data}
                  /></>
          }
        </div>
    )
  }
  if (balanceTableData.type === undefined){
    return (
      <div ref={ref}>
        <h2
          style={{ display: "block", width: "100%", direction: "rtl" }}
          className={"text-center"}
        >
          چیزی برای پرینت وجود ندارد!
        </h2>
      </div>
    );
  }
});

const Factorprint = () => {
  const myRef = useRef();

  return (
    <>
      <div className={"printBalanceBenefit"}  style={{"Width":"100%","Height":"75vh", "overflow":"scroll" }} >
        <div>
          <ReactToPrint content={() => myRef.current}>
            <PrintContextConsumer>
              {({ handlePrint }) => (
                  <button className={"btnCustom btnSubmit"} onClick={handlePrint}>
                    چاپ
                  </button>
              )}
            </PrintContextConsumer>
          </ReactToPrint>
        </div>
          <div style={{"maxWidth":"50vw", "margin":"0 auto"}} className={"mt-3"}>
            <ComponentToPrint ref={myRef} />
          </div>
      </div>
    </>
  );
};

export default Factorprint;
